import axios from "axios";

const host = process.env.REACT_APP_BASE_URL || "https://api.eyeonwellness.org/api";

const registerUser = async (userData) => {
  const response = await axios.post(`${host}/auth/register`, userData);
  return response.data;
};

const loginUser = async (userData) => {
  const response = await axios.post(`${host}/auth/login`, userData);
  return response.data;
};

const getMe = async (token) => {
  const response = await axios.get(`${host}/auth/me`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

const changePassword = async (token, payload) => {
  const response = await axios.post(`${host}/auth/change-password`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export default { registerUser, loginUser, getMe, changePassword };
